import { tickerItems } from '@/mocks/home';

export default function TopTicker() {
  const line = tickerItems.join('   ·   ');

  return (
    <div className="fixed top-0 left-0 right-0 z-50 h-9 bg-foreground-950 text-background-50">
      <div className="flex h-full items-center">
        <div className="flex h-full shrink-0 items-center gap-2 bg-accent-500 px-3 md:px-4">
          <span className="hl-live-dot h-2 w-2 rounded-full bg-background-50" />
          <span className="font-label text-[13px] tracking-wider">实时更新</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="hl-marquee-track pl-4 text-[13px] text-background-100">
            <span className="pr-10">{line}</span>
            <span className="pr-10">{line}</span>
          </div>
        </div>
        <div className="hidden shrink-0 items-center gap-2 border-l border-foreground-700 px-4 md:flex">
          <i className="ri-history-line text-primary-400" />
          <span className="text-[13px] text-background-200">最近巡检：2026-10-10 09:12</span>
        </div>
      </div>
    </div>
  );
}